import { GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED } from '@common/neo.tax';

import { stringifyCsv } from '@neo.tax/shared/utils';

const headers = Object.values(GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED);
export const HEADERS_STRINGIFIED = stringifyCsv([headers]);

const exampleData = [
  headers,
  [
    'Patents',
    'Skadden Aaps, LLP',
    '$60,000.00',
    'CA',
    'United States',
    'OPERATING EXPENSE : R&D EXPENSE : Computer Hardware & Equipmen',
    '1200 - R&D',
    '1101 - R&D',
    '',
  ],
  [
    'Cloud',
    'AWS',
    '$27,000.00',
    'AZ',
    'United States',
    'OPERATING EXPENSE : R&D EXPENSE : Computer Hardware & Equipmen',
    '1200 - R&D',
    '1101 - R&D',
    'France Holding Co',
  ],
  [
    'Cloud',
    'Google Cloud',
    '$23,581.12',
    'NY',
    'United States',
    'OPERATING EXPENSE : IT EXPENSE : Computer Hardware & Equipment',
    '1200 - R&D',
    '1101 - R&D',
    'Manufacturing LLC',
  ],
  [
    'Contractors',
    'Max Martin Group',
    '$45,000.00',
    '',
    'Canada',
    'OPERATING EXPENSE : IT EXPENSE : Computer Hardware & Equipment',
    '500 - Ops',
    '1101 - R&D',
    'US Corporate',
  ],
  [
    'Supplies',
    'Chemical Biologics',
    '$700.00',
    'CA',
    'United States',
    'OPERATING EXPENSE : IT EXPENSE : Computer Hardware & Equipment',
    '500 - Ops',
    '1101 - R&D',
    'US Corporate',
  ],
  [
    'Patents',
    'Legal Pros, LLP',
    '$7,500.00',
    'CA',
    'United States',
    'OPERATING EXPENSE : MISCELLANEOUS BUSINESS EXPENSE : Office Supplies and Expenses',
    '152 - Sales',
    '1101 - R&D',
    '',
  ],
  [
    'Cloud',
    'Accenture',
    '$9,000.00',
    'CA',
    'United States',
    'OPERATING EXPENSE : MISCELLANEOUS BUSINESS EXPENSE : Office Supplies and Expenses',
    '152 - Sales',
    '1101 - R&D',
    '',
  ],
  [
    'Supplies',
    'Chief Medical',
    '$3,200.00',
    'CA',
    'United States',
    'OPERATING EXPENSE : GTM EXPENSE : Computer Hardware & Equipment',
    '152 - Sales',
    '1204 - Data',
    '',
  ],
  ['Contractors', 'Marketing Contractor', '$85,000.00', 'CA', 'United States', '', '', '1204 - Data', ''],
  ['Supplies', 'Iron Ironics', '$14,600.00', 'CA', 'United States', '', '', '1204 - Data', ''],
  ['Patents', 'Always Right, LLP', '$19,500.00', 'CA', 'United States', '', '', '303 - Intel', ''],
  ['Cloud', 'Server Rentals', '$35,000.00', 'CA', 'United States', '', '', '303 - Intel', ''],
  ['Cloud', 'Azure', '$115,000.00', 'CA', 'United States', '', '', '303 - Intel', ''],
  ['Contractors', 'Consultant', '$65,000.00', '', 'United Kingdom', '', '', '104 - Ops', ''],
  ['Supplies', '3-D Printed Prototypes', '$1,500.00', 'CA', 'United States', '', '', '104 - Ops', ''],
];

export const EXAMPLE_DATA_STRINGIFIED = stringifyCsv(exampleData);
